export default __webpack_public_path__ + "static/media/octagons-no-1.469cd261.ogg";